import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class GlobalVariablesService extends RestfulService<Models.GlobalVariable> {

  constructor(public restService: RestService) {
    super(Models.GlobalVariable);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('global-variables');
  }

}
